import React, { useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from 'store/rootStore'
import { isMobile } from 'lib/utils'
import { Container, Grid, makeStyles } from '@material-ui/core'
import AsterButton from 'asterX-UIkit/Buttons/AsterButton'
import CreateModal from './modals/CreateModal'
import * as division from 'constants/divisions'

import icon1 from 'assets/asterx-1.png'
import icon2 from 'assets/help-desk-2.png'
import icon3 from 'assets/help-desk-3.png'
import icon4 from 'assets/help-desk-4.png'
import icon5 from 'assets/help-desk-5.png'
import icon6 from 'assets/help-desk-6.png'
import icon7 from 'assets/help-desk-7.png'
import icon8 from 'assets/help-desk-8.png'
import icon9 from 'assets/help-desk-9.png'
import icon10 from 'assets/help-desk-10.png'
import icon11 from 'assets/access.png'
import icon12 from 'assets/seo.png'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: isMobile() ? 32 : 90,
    paddingTop: 0
  },
  button: {
    width: 'fit-content',
    minHeight: 150,
    height: '100%',
    borderRadius: isMobile() ? 45 : 60,
    margin: isMobile() ? 0 : 0,
    display: 'block'
  }
}))

const menuList = [
  {
    icon: icon11,
    division: division.HELP_DESK_DIVISION,
    module: 'Доступы'
  },
  { icon: icon1, division: division.ASTERX_DIVISION, module: '' },
  {
    icon: icon12,
    division: division.ASTERX_DIVISION,
    module: 'СЭО'
  },
  { icon: icon2, division: division.HELP_DESK_DIVISION, module: '1C' },
  {
    icon: icon3,
    division: division.HELP_DESK_DIVISION,
    module: 'Программное обеспечение'
  },
  {
    icon: icon4,
    division: division.HELP_DESK_DIVISION,
    module: 'Сеть и интернет'
  },
  {
    icon: icon5,
    division: division.HELP_DESK_DIVISION,
    module: 'Сотовая связь'
  },
  { icon: icon6, division: division.HELP_DESK_DIVISION, module: 'Устройства' },
  {
    icon: icon7,
    division: division.HELP_DESK_DIVISION,
    module: 'Запрос на технику'
  },
  { icon: icon8, division: division.HELP_DESK_DIVISION, module: 'Прочее' },
  {
    icon: icon9,
    division: division.HELP_DESK_DIVISION,
    module: 'СКУД'
  },
  {
    icon: icon10,
    division: division.HELP_DESK_DIVISION,
    module: 'Видеонаблюдение'
  }
]

const CreationPanel = () => {
  const classes = useStyles()
  const { authStore } = useContext(RootStoreContext)
  const [isOpen, setIsOpen] = useState(false)
  const [prevForm, setPrevForm] = useState({})

  const handleOpen = data => {
    authStore.setDivision(data.division)
    setPrevForm({ module: data.module })
    setIsOpen(true)
  }
  return (
    <Container className={classes.root} fullWidth>
      <Grid
        container
        direction={'row'}
        justify={'center'}
        alignItems={'center'}
        spacing={4}
      >
        {menuList.map(item => (
          <Grid item xs={6} md={3}>
            <AsterButton
              onClick={() => handleOpen(item)}
              className={classes.button}
            >
              <img src={item.icon} width="70%" />
              <p>{item.module || 'AsterX'}</p>
            </AsterButton>
          </Grid>
        ))}
      </Grid>
      {isOpen && (
        <CreateModal
          open={isOpen}
          prevForm={prevForm}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Container>
  )
}

export default observer(CreationPanel)
